import React from 'react';
const faqs = [{
  q: '¿El material es físico o digital?',
  a: 'Es un producto 100% digital. Inmediatamente después de tu compra, recibirás un correo electrónico con el acceso a todo el material para que puedas descargarlo, imprimirlo o verlo desde tu celular, tablet o computadora.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tienes una garantía incondicional de 7 días. Si sientes que el material no es lo que esperabas o no te ayuda, simplemente nos envías un correo y te devolvemos el 100% de tu dinero sin hacer preguntas.'
}, {
  q: '¿Los métodos de pago son seguros?',
  a: 'Totalmente. Utilizamos la plataforma de Hotmart, líder mundial en productos digitales, que cuenta con los más altos estándares de seguridad y encriptación para proteger tus datos.'
}, {
  q: 'No soy muy tecnológico, ¿podré usarlo?',
  a: '¡Sí! El sistema está diseñado para ser extremadamente fácil de usar. Solo necesitas hacer clic en el enlace que te enviaremos y podrás ver todo el contenido. Además, la letra es grande y clara.'
}];
export function FAQSection() {
  return <section className="w-full bg-sky-soft py-20 px-5 sm:px-8 lg:px-12 border-t border-navy/10" data-id="element-9">
      <div className="max-w-5xl mx-auto" data-id="element-10">
        <h2 className="font-serif text-navy text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-11">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-5" data-id="element-12">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white border border-navy/10 rounded-xl p-6 shadow-panel" data-id="element-13">
              <h3 className="text-navy font-bold text-lg mb-2" data-id="element-14">{faq.q}</h3>
              <p className="text-navy/60 text-sm leading-relaxed" data-id="element-15">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}